import React from 'react';
import { Box, Typography } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';
import BatchCard from './BatchCard';

/**
 * BatchShelf — horizontal scroll shelf of BatchCards.
 *
 * @param {object[]} batches
 * @param {(plan) => void} onShowInterest
 * @param {(videoUrl: string) => void} onPlayVideo
 * @param {(images: string[], index: number) => void} onOpenLightbox
 * @param {(path: string) => string} getImageUrl
 * @param {(date) => string|null} formatDate
 * @param {(url) => string|null} getYouTubeThumbnail
 * @param {(url) => string|null} getYouTubeVideoId
 */
function BatchShelf({
  batches,
  onShowInterest,
  onPlayVideo,
  onOpenLightbox,
  getImageUrl,
  formatDate,
  getYouTubeThumbnail,
  getYouTubeVideoId,
}) {
  if (batches.length === 0) {
    return (
      <Box
        sx={{
          p: 4,
          textAlign: 'center',
          borderRadius: '16px',
          border: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <CalendarToday sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
        <Typography color="text.secondary">
          No upcoming batches yet — new batches typically open 4&ndash;6 weeks before start. Express interest to be notified.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        overflowX: 'auto',
        pb: 2,
        '&::-webkit-scrollbar': { height: 8 },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'rgba(0,0,0,0.05)',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,0.2)',
          borderRadius: '4px',
        },
      }}
    >
      {batches.map((batch) => (
        <BatchCard
          key={batch.id}
          batch={batch}
          onPlayVideo={onPlayVideo}
          onShowInterest={onShowInterest}
          onOpenLightbox={onOpenLightbox}
          getImageUrl={getImageUrl}
          formatDate={formatDate}
          getYouTubeThumbnail={getYouTubeThumbnail}
          getYouTubeVideoId={getYouTubeVideoId}
        />
      ))}
    </Box>
  );
}

export default BatchShelf;
